import {
  TRADITION_GROUPS,
  TRADITION_LABELS,
  TRADITION_SUBCATEGORIES,
  type Tradition,
  type TraditionGroup,
} from '../theme/tokens';

const TRADITION_EMOJI: Record<Tradition, string> = {
  christian: '✝️',
  catholic: '⛪',
  protestant: '📖',
  orthodox_christian: '☦️',
  islamic: '☪️',
  sunni: '☪️',
  shia: '☪️',
  hindu: '🕉️',
  vaishnavism: '🪷',
  shaivism: '🔱',
  shaktism: '🌺',
  buddhist: '☸️',
  theravada: '🌿',
  mahayana: '🪷',
  vajrayana: '💎',
  chinese_folk: '🏮',
  taoist: '☯️',
  religious_taoism: '🏮',
  philosophical_taoism: '☯️',
  jewish: '✡️',
  orthodox_judaism: '✡️',
  conservative_judaism: '✡️',
  reform_judaism: '✡️',
  crystal_healing: '💎',
  sound_bath: '🔔',
  aromatherapy: '🌸',
  chromotherapy: '🌈',
  somatic_mindfulness: '🎯',
  earthing: '🪨',
  breathwork: '🌬️',
  qi_gong: '🥋',
  floatation: '🌊',
  stoic: '🏛️',
};

const GROUPS: TraditionGroup[] = ['Major Religions', 'Alternative Practices'];

interface TraditionPickerProps {
  selected: Tradition[];
  onChange: (traditions: Tradition[]) => void;
}

export function TraditionPicker({ selected, onChange }: TraditionPickerProps) {
  const toggle = (t: Tradition) => {
    if (selected.includes(t)) {
      onChange(selected.filter((x) => x !== t));
    } else {
      onChange([...selected, t]);
    }
  };

  return (
    <div className="tradition-groups">
      {GROUPS.map((group) => (
        <div key={group} className="tradition-group">
          <h3 className="tradition-group-title">{group}</h3>
          <div className="tradition-grid">
            {TRADITION_GROUPS[group].map((t) => {
              const subs = TRADITION_SUBCATEGORIES[t];
              return (
                <div key={t} className={subs ? 'tradition-item has-subs' : 'tradition-item'}>
                  <button
                    type="button"
                    className={`tradition-chip${selected.includes(t) ? ' selected' : ''}`}
                    onClick={() => toggle(t)}
                    aria-pressed={selected.includes(t)}
                  >
                    <span className="emoji" aria-hidden="true">{TRADITION_EMOJI[t]}</span>
                    <span>{TRADITION_LABELS[t]}</span>
                  </button>

                  {subs && (
                    <div className="tradition-subgrid">
                      {subs.map((s) => (
                        <button
                          key={s}
                          type="button"
                          className={`tradition-chip tradition-subchip${selected.includes(s) ? ' selected' : ''}`}
                          onClick={() => toggle(s)}
                          aria-pressed={selected.includes(s)}
                        >
                          <span className="emoji" aria-hidden="true">{TRADITION_EMOJI[s]}</span>
                          <span>{TRADITION_LABELS[s]}</span>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
